import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement, Fragment } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { useEntityProp, __experimentalUseEntitySaving } from '@wordpress/core-data';
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { RichText } from '@wordpress/block-editor';
export default function SiteTitleEdit() {
  var _useEntityProp = useEntityProp('root', 'site', 'title'),
      _useEntityProp2 = _slicedToArray(_useEntityProp, 2),
      title = _useEntityProp2[0],
      setTitle = _useEntityProp2[1];

  var _experimentalUseEnti = __experimentalUseEntitySaving('root', 'site', 'title'),
      _experimentalUseEnti2 = _slicedToArray(_experimentalUseEnti, 3),
      isDirty = _experimentalUseEnti2[0],
      isSaving = _experimentalUseEnti2[1],
      save = _experimentalUseEnti2[2];

  return createElement(Fragment, null, createElement(Button, {
    isPrimary: true,
    className: "wp-block-site-title__save-button",
    disabled: !isDirty || !title,
    isBusy: isSaving,
    onClick: save
  }, __('Update')), createElement(RichText, {
    tagName: "h1",
    placeholder: __('Site Title'),
    value: title,
    onChange: setTitle,
    allowedFormats: []
  }));
}